import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { governanceProjectsDirectoryRoute } from '@jira/router-routes__governance-projects-directory-routes/src/governanceProjectsDirectoryRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { governanceProjectsAdminEntryPoint } from '@jira/spa-apps__admin-pages-governance-projects/src/governanceProjectsAdminEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';

const governanceProjectsAdminPageEntryPoint = createPageEntryPoint({
	main: governanceProjectsAdminEntryPoint,
});

export const governanceProjectsDirectoryRouteEntry: Route = createEntry(
	governanceProjectsDirectoryRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.governance-projects',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		entryPoint: () =>
			expValEquals('frontier-guided-autonomy-eap', 'isEnabled', true, false)
				? governanceProjectsAdminPageEntryPoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
